var _templateObject;

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}

import React from "react";
import { Box, Heading, Paragraph, ResponsiveContext } from "grommet";
import styled from "styled-components";
import { routes } from "../../const/routes";
var StyledLink = styled.a(
  _templateObject ||
    (_templateObject = _taggedTemplateLiteralLoose([
      "\n  text-decoration: none;\n  color: white;\n  font-size: 18px;\n\n  &:hover {\n    opacity: 0.7;\n  }\n",
    ]))
);
export var ImageWithLink = function ImageWithLink(_ref) {
  var image = _ref.image,
    paragraph = _ref.paragraph,
    heading = _ref.heading,
    link = _ref.link,
    _ref$extraInfo = _ref.extraInfo,
    extraInfo = _ref$extraInfo === void 0 ? false : _ref$extraInfo,
    as = _ref.as;
  return /*#__PURE__*/ React.createElement(
    React.Fragment,
    null,
    /*#__PURE__*/ React.createElement(ResponsiveContext.Consumer, null, function (size) {
      return /*#__PURE__*/ React.createElement(
        Box,
        {
          width: {
            max: "684px",
            min: "auto",
          },
          height: {
            min: size === "small" ? "401px" : "464px",
          },
          round: "20px",
          background: {
            image:
              "linear-gradient(rgba(255, 255, 255, 0), rgba(0, 0, 0, 0.8)), url(" + image + ")",
            size: "cover",
          },
        },
        /*#__PURE__*/ React.createElement(
          Box,
          {
            flex: true,
            justify: "end",
            pad: "large",
            gap: "small",
          },
          /*#__PURE__*/ React.createElement(
            Heading,
            {
              level: 3,
              color: "white",
            },
            heading
          ),
          /*#__PURE__*/ React.createElement(
            Box,
            {
              gap: "large",
            },
            /*#__PURE__*/ React.createElement(
              Paragraph,
              {
                size: "1rem",
                color: "white",
                fill: true,
              },
              paragraph
            ),
            extraInfo
              ? /*#__PURE__*/ React.createElement(
                  StyledLink,
                  {
                    as: as,
                    to: link,
                  },
                  "\u0427\u0438\u0442\u0430\u0442\u044C \u0434\u0430\u043B\u0435\u0435"
                )
              : /*#__PURE__*/ React.createElement(
                  StyledLink,
                  {
                    as: as,
                    to: routes.news.path + "/" + link,
                  },
                  "\u0427\u0438\u0442\u0430\u0442\u044C \u0434\u0430\u043B\u0435\u0435"
                )
          )
        )
      );
    })
  );
};
